// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2O-p2","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__17I3p"};